"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassStatusPicker = void 0;
const PassStatus_1 = __importDefault(require("@opsbase/lib-grading/PassStatus"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const FailIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FailIcon"));
const PassIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PassIcon"));
const UndeterminedIcon_1 = __importDefault(require("@opsbase/web-icons/icons/UndeterminedIcon"));
const IconTitle_1 = __importDefault(require("@opsbase/web-ui/IconTitle"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const react_1 = __importStar(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.PassStatusPicker = (0, makePicker_1.default)((props) => {
    const passIcon = (0, react_1.useMemo)(() => react_1.default.createElement(PassIcon_1.default, { color: lib_palette_1.default.positive }), []);
    const failIcon = (0, react_1.useMemo)(() => react_1.default.createElement(FailIcon_1.default, { color: lib_palette_1.default.error }), []);
    const undeterminedIcon = (0, react_1.useMemo)(() => react_1.default.createElement(UndeterminedIcon_1.default, { color: lib_palette_1.default.GreyBlue }), []);
    const renderValue = (0, react_1.useMemo)(() => v => v === PassStatus_1.default.PASS ? passIcon : v === PassStatus_1.default.FAIL ? failIcon : undeterminedIcon, [failIcon, passIcon, undeterminedIcon]);
    return (react_1.default.createElement(Select_1.default, Object.assign({}, props, { renderValue: renderValue }),
        react_1.default.createElement(MenuItem_1.default, { value: PassStatus_1.default.PASS },
            react_1.default.createElement(IconTitle_1.default, { title: lib_i18n_1.default.t('pass'), icon: passIcon })),
        react_1.default.createElement(MenuItem_1.default, { value: PassStatus_1.default.FAIL },
            react_1.default.createElement(IconTitle_1.default, { title: lib_i18n_1.default.t('fail'), icon: failIcon })),
        react_1.default.createElement(MenuItem_1.default, { value: PassStatus_1.default.UNDETERMINED },
            react_1.default.createElement(IconTitle_1.default, { title: lib_i18n_1.default.t('undetermined'), icon: undeterminedIcon }))));
});
exports.default = exports.PassStatusPicker;
